import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

export enum LogoutReason {
  Manual = 'manual',
  InvalidGrant = 'invalid_grant',
  NotAuthenticated = 'not_authenticated',
  NoAuthData = 'no_auth_data',
}

export interface LogoutInfo {
  reason: LogoutReason;
  userId?: string;
  email?: string;
  databaseIdentifier?: string;
}

@Injectable({ providedIn: 'root' })
export class AuthProvider {
  private readonly _doLogin = new ReplaySubject();
  public readonly doLogin$ = this._doLogin.asObservable();

  private readonly _doLogout = new ReplaySubject<LogoutInfo>();
  public readonly doLogout$ = this._doLogout.asObservable();

  public loggedIn: boolean;

  loginEvent() {
    this.loggedIn = true;
    this._doLogin.next(true);
  }

  logoutEvent(info: LogoutInfo) {
    this.loggedIn = false;
    this._doLogout.next(info);
  }
}
